import { render, staticRenderFns } from "./ja-JP.vue?vue&type=template&id=2362138b&"
import script from "./ja-JP.vue?vue&type=script&lang=js&"
export * from "./ja-JP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2362138b')) {
      api.createRecord('2362138b', component.options)
    } else {
      api.reload('2362138b', component.options)
    }
    module.hot.accept("./ja-JP.vue?vue&type=template&id=2362138b&", function () {
      api.rerender('2362138b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/ja-JP.vue"
export default component.exports